//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//api
import { api } from '../../../../functions/api';

//custom components
import CustomInput from '../../../../components/basic/input';
import CustomAvatar from '../../../../components/basic/customAvatar';

//material-ui
import { Grid, Paper } from '@material-ui/core'

//other libraries

@inject('internal')
@inject('translate')
@observer
export default class BasicInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    timeout = null

    handleOnChange = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateData()
        }, 500)
    }

    updateData = async() => {
        let url = this.url.state.value
        if(url.substr(-1) !== '/') {
            url += "/"
        }

        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'PATCH',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                iban: this.iban.state.value,
                id_no: this.id_no.state.value,
                id_vat: this.id_vat.state.value,
                url: url,
                name: this.name.state.value,
                feedback_email: this.feedback_email.state.value,
                feedback_description: this.feedback_description.state.value,
                feedback_phone: this.feedback_phone.state.value,
                from_email: this.from_email.state.value,
                mini_banner_url: this.mini_banner_url.state.value,
                mini_banner_2_url: this.mini_banner_2_url.state.value,
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    handleChangePhoto = async (data) => {
        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'POST',
            url: `lists/shops/${id}`,
            formData: true,
            // formDataPut: true,
            authorization: this.props.internal.user.access_token,
            params: {
                email_logo: data
            },

        })

        if (update_data.success && update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
    }

    handleChangeMiniBanner = async (key, data) => {
        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'POST',
            url: `lists/shops/${id}`,
            formData: true,
            // formDataPut: true,
            authorization: this.props.internal.user.access_token,
            params: {
                [key]: data
            },

        })

        if (update_data.success && update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
    }

    render () {
        return (
            <div className={'shopDetailContainer'}>
                <div className="content">
                    <Grid container spacing={16} >
                        <Grid item xs={12} sm={6}>
                            <Paper className={'paperContainer'}>
                                <CustomInput
                                    ref={ref => (this.iban = ref)}
                                    text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.IBAN}
                                    value={toJS(this.props.internal.dataForTable.iban)}
                                    id={"iban"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                                <CustomInput
                                    ref={ref => (this.id_no = ref)}
                                    text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.ICO}
                                    value={toJS(this.props.internal.dataForTable.id_no)}
                                    id={"id_no"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                                <CustomInput
                                    ref={ref => (this.id_vat = ref)}
                                    text={this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.IC_DPH}
                                    value={toJS(this.props.internal.dataForTable.id_vat)}
                                    id={"id_vat"}
                                    className={"w-100"}
                                    change={this.handleOnChange}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={16}>
                                <Grid item xs={12}>
                                    <Paper className={'paperContainer'}>
                                        <CustomInput
                                            ref={ref => (this.name = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.NAME}
                                            value={toJS(this.props.internal.dataForTable.name)}
                                            id={"name"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper className={'paperContainer'}>
                                        <CustomInput
                                            ref={ref => (this.url = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.URL}
                                            value={toJS(this.props.internal.dataForTable.url)}
                                            id={"url"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Paper className={'paperContainer'}>
                                <div className={'ourStoryImage'}>
                                    <CustomAvatar
                                        src={`${toJS(this.props.internal.dataForTable.email_logo)}`}
                                        actionUploadPhoto={this.handleChangePhoto}
                                        disableEdit={false}
                                        // id={'email-logo'}
                                    />
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Paper className={'paperContainer'}>
                                <Grid container spacing={16}>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => (this.feedback_description = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.FEEDBACK_DESCRIPTION}
                                            value={toJS(this.props.internal.dataForTable.feedback_description)}
                                            id={"feedback_description"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CustomInput
                                            ref={ref => (this.feedback_email = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.FEEDBACK_EMAIL}
                                            value={toJS(this.props.internal.dataForTable.feedback_email)}
                                            id={"feedback_email"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CustomInput
                                            ref={ref => (this.feedback_phone = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.FEEDBACK_PHONE}
                                            value={toJS(this.props.internal.dataForTable.feedback_phone)}
                                            id={"feedback_phone"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <CustomInput
                                            ref={ref => (this.from_email = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.SHOP_FROM_EMAIL}
                                            value={toJS(this.props.internal.dataForTable.from_email)}
                                            id={"from_email"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                            required
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Paper className={'paperContainer'}>
                                <div>{this.props.translate.i18n.MODULES.SHOPS.MINI_BANNER_IMAGE}</div>
                                <div className={'ourStoryImage'}>
                                    <CustomAvatar
                                        src={`${toJS(this.props.internal.dataForTable.mini_banner_image)}`}
                                        alt={this.props.translate.i18n.MODULES.SHOPS.MINI_BANNER_IMAGE}
                                        actionUploadPhoto={data => this.handleChangeMiniBanner('mini_banner_image', data)}
                                        disableEdit={false}
                                        // id={'mini-banner-image'}
                                    />
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Paper className={'paperContainer'}>
                                <Grid container spacing={16}>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => (this.mini_banner_url = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.MINI_BANNER_URL}
                                            value={toJS(this.props.internal.dataForTable.mini_banner_url)}
                                            id={"mini_banner_url"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Paper className={'paperContainer'}>
                                <div>{this.props.translate.i18n.MODULES.SHOPS.MINI_BANNER_2_IMAGE}</div>
                                <div className={'ourStoryImage'}>
                                    <CustomAvatar
                                        src={`${toJS(this.props.internal.dataForTable.mini_banner_2_image)}`}
                                        alt={this.props.translate.i18n.MODULES.SHOPS.MINI_BANNER_IMAGE}
                                        actionUploadPhoto={data => this.handleChangeMiniBanner('mini_banner_2_image', data)}
                                        disableEdit={false}
                                        // id={'mini-banner-image'}
                                    />
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Paper className={'paperContainer'}>
                                <Grid container spacing={16}>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => (this.mini_banner_2_url = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.MINI_BANNER_2_URL}
                                            value={toJS(this.props.internal.dataForTable.mini_banner_2_url)}
                                            id={"mini_banner_2_url"}
                                            className={"w-100"}
                                            change={this.handleOnChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/shops/detail/basic/BasicInfo.jsx